import '@babel/polyfill';

import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { ModalProvider } from '../../../components/modal/ModalProvider';
import { createStore } from '../../../state/store';
import { LanguageContextProvider } from '../../../navigation/localization/ContentLanguageContext';
import { UserProvider } from '../../../user/UserContext';
import { getLocalByCountry, getLocalMessages } from '../../../translateUtils';
import { getDefaultState } from '../../../state/store/getDefaultState';
import { isClientSide } from '../../../utils/ssrUtils';

export const CommonAppProviders: FC = ({ children }) => {
  const globalInitialState = getDefaultState(
    isClientSide ? window.location.search : '',
    isClientSide ? window : {},
  );

  const globalStore = createStore(globalInitialState);
  const countryCode = (isClientSide && window.COUNTRY_CODE) || 'fr';
  const locale = getLocalByCountry(countryCode);

  return (
    <Provider store={globalStore}>
      <IntlProvider
        locale={locale}
        key={locale}
        messages={getLocalMessages(locale)}
      >
        <LanguageContextProvider>
          <UserProvider>
            <ModalProvider>{children}</ModalProvider>
          </UserProvider>
        </LanguageContextProvider>
      </IntlProvider>
    </Provider>
  );
};
